import _ from 'lodash'
import moment from 'moment'
import {
  API_DATETIME_FORMAT,
  OFFER_DATE_TIME_FORMAT,
} from '../constants/statics'
import { conformToMask, phoneNumberMask } from './inputMasks'

export const formatMoney = (
  val,
  overrides,
  hideDecimals = false,
  defaultValue = ''
) => {
  if (Number.isFinite(val)) {
    const number = hideDecimals ? Number.parseInt(val) : Number.parseFloat(val)
    const minimumFractionDigits = Number.isInteger(number) ? 0 : 2
    return number.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits,
      ...overrides,
    })
  }
  return val || defaultValue
}

export const formatTitleCase = (val, wordsToCapitalize = []) => {
  if (_.isNil(val)) return ''
  const titleCasedStr = _.startCase(_.lowerCase(String(val)))

  if (!wordsToCapitalize.length) {
    return titleCasedStr
  } else {
    const splitStr = titleCasedStr.split(' ')

    wordsToCapitalize.forEach(word => {
      const indexOfWord = splitStr.indexOf(_.startCase(word))

      if (indexOfWord !== -1) {
        splitStr[indexOfWord] = _.upperCase(word)
      }
    })

    return splitStr.join(' ')
  }
}

export const removeFileExtension = (fileName, extensionsToRemove = []) => {
  const removeSet = new Set(extensionsToRemove)
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot === -1) return fileName
  const lastStr = fileName.substring(lastDot + 1)
  return removeSet.has(lastStr) ? fileName.substring(0, lastDot) : fileName
}

/**
 *
 * @param {datetime} d
 * @returns API date format (utc)
 */
export const dateToApiString = d => moment(d).utc().format(API_DATETIME_FORMAT)

/**
 * Converts API (utc) string to local moment
 * @param {string} s
 * @returns moment in local mode
 */
export const apiStringToLocalMoment = s =>
  moment.utc(s, API_DATETIME_FORMAT).local()

export const formatPhoneNumber = value => {
  const digits = (value + '').replace(/[^\d]/g, '')

  // NOTE: This can cause weird results if QA randomized these numbers because it's possible to get numbers with
  // a leading 0, in which case `parseInt` will strip it from the result and cause this condition to fail and the
  // formatting not to be added
  return digits.length === 10 && digits === '' + parseInt(digits, 10)
    ? conformToMask(digits, phoneNumberMask).conformedValue
    : value
}

// This is useful if you want to render presentation states for an enum and want decent default behavior for if backend
// adds new values to the schema without the app updating at the same time
export const formatEnum = enumVal =>
  (enumVal || '').split('_').map(_.capitalize).join(' ')

export const formatDate = (date, format = OFFER_DATE_TIME_FORMAT) =>
  apiStringToLocalMoment(date).format(format)
